/**
 * Implements scroll assist for a sticky sidebar that is displayed next to other content.
 *
 * The assist does the following:
 *
 * - Scrolls the scroll pane to the top when the user scrolls up past the container
 * - Scrolls the scroll pane to the bottom when the user scrolls down past the container
 */
(() => {
    let targets = document.querySelectorAll(
        '.js-sticky-sidebar-scroll-assist-target'
    );

    if (!targets.length || typeof H_Tools.scroll_tools === 'undefined') {
        return;
    }

    targets.forEach((target) => {
        new IntersectionObserver(
            (entries, observer) => {
                let container = entries[0].target.closest(
                    '.js-sticky-sidebar-scroll-assist-container'
                );

                if (!container) {
                    return;
                }

                const content = container.querySelector(
                    '.js-sticky-sidebar-scroll-assist-content'
                );

                if (
                    !H_Tools.scroll_tools.isScrollingDown &&
                    content.getBoundingClientRect().top > 0
                ) {
                    entries[0].target.scrollTop = 0;
                }

                if (
                    !entries[0].isIntersecting &&
                    content.getBoundingClientRect().top < 0
                ) {
                    entries[0].target.scrollTop =
                        entries[0].target.scrollHeight;
                }
            },
            {
                threshold: 1,
            }
        ).observe(target);
    });
})();
